export default __webpack_public_path__ + "static/media/done_deal_migration2.edd0f7bf.svg";